/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HospitalizationDto } from '../../models/hospitalization-dto';
import { PrehospiCreationDto } from '../../models/prehospi-creation-dto';

export interface HospitalizationCreateKioskPrehospi$Params {
  
    /**
     * filter criteria
     */
    body?: PrehospiCreationDto
}

export function hospitalizationCreateKioskPrehospi(http: HttpClient, rootUrl: string, params?: HospitalizationCreateKioskPrehospi$Params, context?: HttpContext): Observable<StrictHttpResponse<HospitalizationDto>> {
  const rb = new RequestBuilder(rootUrl, hospitalizationCreateKioskPrehospi.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HospitalizationDto>;
    })
  );
}

hospitalizationCreateKioskPrehospi.PATH = '/v1/Hospitalization/CreateKioskPrehospi';
